import Agent, {
  type AgentSuggestions,
  type AgentParams,
  type AgentInstances,
} from './Agent';

class WritingAgent extends Agent {
  static name = 'WritingAgent';

  static publicName = 'Writing';

  static available(
    _agentParams: AgentParams,
    agentInstances: AgentInstances
  ): boolean {
    return Boolean(
      window.currentAccount?.hasGeneralAiAssistant &&
        agentInstances.assistedEditor
    );
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'Outline',
        prompt:
          'Tell me what you are thinking through and the level of detail that you want in your outline.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create an outline of a topic to insert at the end of the document.\n\nUse bullet points for the outline.\n\nLet's start...  \n\nThe topic is: `,
        icon: 'list',
      },
      {
        title: 'Draft',
        prompt:
          'Tell me what you are writing and share some details about what to include and the tone. You can add example text and even refer to existing Aha! records by their ID.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to draft a document.\n\nBefore starting though determine if I have told you how long I want the document. If not, ask me.
Let's start...\n\nThe document is: `,
        icon: 'draft',
      },
      {
        title: 'Summarize',
        prompt: 'Tell me what you are distilling.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to summarize text.\n\nBefore starting though determine if I have told you how I would like you to summarize the text. If not, ask.
Let's start...\n\nThe text is: `,
        icon: 'summarize',
      },
    ];
  }
}

Agent.register(WritingAgent);
